/**
 * @file Form Signature
 */

import SignaturePad from 'signature_pad';
import throttle from 'just-throttle';

/**
 * Form Signature component
 */
const vFormSignature = () => {
    const formSignature = document.querySelector( '.v-form-signature' );

    if ( ! formSignature ) {
        return;
    }

    const signatureForm   = formSignature.querySelector( '.v-form-signature__form' );
    const signatureCanvas = formSignature.querySelector( '.v-form-signature__canvas' );
    const signatureClear  = formSignature.querySelector( '.v-form-signature__clear' );
    const signatureInput  = formSignature.querySelector( 'input[name$="_signature_uri"]' );
    const dateInput       = formSignature.querySelector( 'input[name$="_date"]' );

    const signaturePad = new SignaturePad( signatureCanvas );
    const resizeCanvas =  () => {
        const existingContent = signatureCanvas.getContext( '2d' ).getImageData( 0, 0, signatureCanvas.width, signatureCanvas.height );
        const ratio =  Math.max( window.devicePixelRatio || 1, 1 );
        signatureCanvas.width = signatureCanvas.offsetWidth * ratio;
        signatureCanvas.height = signatureCanvas.offsetHeight * ratio;
        signatureCanvas.getContext( '2d' ).scale( ratio, ratio );
        signaturePad.clear();
        signatureCanvas.getContext( '2d' ).putImageData( existingContent, 0, 0 );
    };

    const cropSignatureCanvas = () => {
        // First duplicate the canvas to not alter the original
        const croppedCanvas = document.createElement('canvas');
        const croppedCtx    = croppedCanvas.getContext('2d');

        croppedCanvas.width  = signatureCanvas.width;
        croppedCanvas.height = signatureCanvas.height;
        croppedCtx.drawImage(signatureCanvas, 0, 0);

        // Next do the actual cropping
        const imageData = croppedCtx.getImageData( 0, 0, croppedCanvas.width, croppedCanvas.height);
        const pix       = {x:[], y:[]};
        let w           = croppedCanvas.width;
        let h           = croppedCanvas.height;
        let x, y, index;

        for ( y = 0; y < h; y++ ) {
            for ( x = 0; x < w; x++ ) {
                index = ( y * w + x ) * 4;
                if ( imageData.data[ index + 3 ] > 0 ) {
                    pix.x.push( x );
                    pix.y.push( y );

                }
            }
        }
        pix.x.sort( ( a, b ) => a - b );
        pix.y.sort( ( a, b ) => a - b );
        const n = pix.x.length-1;

        w = pix.x[n] - pix.x[0];
        h = pix.y[n] - pix.y[0];
        const cut = croppedCtx.getImageData( pix.x[0], pix.y[0], w, h );

        croppedCanvas.width = w;
        croppedCanvas.height = h;
        croppedCtx.putImageData( cut, 0, 0 );

        return croppedCanvas.toDataURL();
    };

    const clearSignature = () => {
        signaturePad.clear();

        if ( signaturePad.isEmpty() ) {
            signatureClear.setAttribute( 'disabled', 'disabled' );
        }
    };

    const validateSignature = () => {
        const today          = new Date();
        const signatureDate  = dateInput.value
        const name           = signatureForm.querySelector( 'input[name$="_patient_name"]' );
        const signatureEmpty = signaturePad.isEmpty();
        let valid            = true;

        // Check if the signature is empty
        if ( signatureEmpty ) {
            const signatureError = signatureForm.querySelector( '.v-form-signature__signature-error' );
            signatureError.innerHTML = 'Please sign the form.';
            valid = false;
        }

        // Check if the patient name is empty
        if ( ! name.value.trim().length > 0 ) {
            const nameError = signatureForm.querySelector( '.v-form-signature__name-error' );
            nameError.innerHTML = 'Please enter the patient\'s name.';
            valid = false;
        }

        // Check if the signature date is empty or not equal to today
        if ( ! signatureDate.length > 0 ||
            ( new Date( signatureDate ) ).toISOString().slice(0, 10) !== today.toISOString().slice(0, 10)
        ) {
            const dateError = signatureForm.querySelector( '.v-form-signature__date-error' );
            dateError.innerHTML = 'Please enter today\'s date.';
            valid = false;
        }

        return valid;
    };

    signaturePad.addEventListener( 'endStroke', () => {
        if ( ! signaturePad.isEmpty() && signatureClear.hasAttribute( 'disabled' ) ) {
            signatureClear.removeAttribute( 'disabled' );
        }
    } );

    signatureClear.addEventListener( 'click', clearSignature );

    signatureForm.addEventListener( 'submit', (e) => {
        e.preventDefault();
        signatureForm.querySelectorAll( '.v-form-signature__error' ).forEach( el => el.innerHTML = '' );

        if ( ! validateSignature() ) {
            return false;
        }

        signatureClear.setAttribute( 'disabled', 'disabled' );
        signatureClear.removeEventListener( 'click', signatureClear.onclick );
        signatureInput.value = cropSignatureCanvas();
        signaturePad.off();

        signatureForm.submit();
    } );

    window.addEventListener(
        'resize',
        throttle(
            resizeCanvas,
            500,
            { leading: true }
        ),
    );
    resizeCanvas();
};

export default vFormSignature;
